export default __webpack_public_path__ + "static/SuisseIntl-Regular-WebS-817642b2a06e9f9ff51e9789ac327be9.woff";